import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { setRelevantPodcastGenres } from '../../lib/fileUtils';
import { firestoreApi, getRelevantGenres, initialGenreCount, mergedAdPodcasts, podcastTypes } from '../../lib/utils';
import FireStoreParser from 'firestore-parser';
import AppSideScroll from './AppSideScroll';
import { spacing } from '../../lib/theme';
import { TOP_10 } from '../../lib/strings';
import Podcast from '../Podcast/Podcast';
import { connect } from 'react-redux';

class RelevantPodcasts extends Component {
    constructor(props) {
        super(props);
        this.state = { relevantGenrePodcasts: {}, neededGenreId: '' };
    }

    componentDidMount() {
        const { subscribedPodcasts } = this.props;
        console.dir(subscribedPodcasts);
        this.relevantPodcastsComponent(subscribedPodcasts);

    }

    relevantPodcastsComponent(subscribedPodcasts) {
        let sortedGenres = getRelevantGenres(subscribedPodcasts);
        for (let i = 0; i <= initialGenreCount - 1; i++) {
            let genre = sortedGenres[i];
            let genreMap = podcastTypes.find((podcastType) => podcastType['name'].includes(genre));
            if (genreMap) {
                let genreId = genreMap['id']; //.replace('-and-', ' & ');
                this.setState({ neededGenreId: genreId });
                setRelevantPodcastGenres([genreMap]);
                console.log('genreCount genreId : ' + genreId);
                setTimeout(() => {
                    // fetch(`${cdnApi}browsePodcasts?id=${encodeURIComponent(genreId)}`).then(async (res) => {
                    fetch(firestoreApi + `topPodcasts/${genreId}/1/podcasts`).then(async (res) => {
                        const json = await res.json();
                        const parsedFirestoreJSON = FireStoreParser(json);
                        // console.dir(parsedFirestoreJSON);
                        const finalJsonArray = parsedFirestoreJSON?.fields?.podcasts || [];


                        // const json = await res.json();
                        // const podcastsData = json.podcastsData;
                        // console.dir(podcastsData);
                        // console.dir(genreMap);
                        const { relevantGenrePodcasts } = this.state;
                        this.setState({
                            relevantGenrePodcasts: { ...relevantGenrePodcasts, [genreMap['name']]: finalJsonArray }
                        });
                    });
                    // store.dispatch(getBrowsePodcasts(genreId));
                }, i * 1000);
                // Future.delayed(Duration(seconds: i), () {
                //   store.dispatch(getBrowsePodcasts(genreId));
                // });
            }
        }
    }

    render() {
        const { adPodcasts } = this.props;
        const { neededGenreId, relevantGenrePodcasts } = this.state;

        console.dir(adPodcasts);
        console.dir(neededGenreId);
        const adPodcastsSpecific = adPodcasts[TOP_10] || [];
        console.dir(relevantGenrePodcasts);
        console.dir(adPodcastsSpecific);
        // console.dir(mergedAdPodcasts(podcastsArray, adPodcastsSpecific));
        return (
            <div>
                {(Object.entries(relevantGenrePodcasts)).map(([key, val]) =>
                    <div key={key} style={{ marginTop: spacing('lg') }}>
                        <AppSideScroll title={`Top ${key} Podcasts`}>
                            {
                                mergedAdPodcasts(val, adPodcastsSpecific).map((podcast, index) =>
                                    <div key={index} style={{ marginRight: `${spacing('lg')}` }}>
                                        <Podcast className='cards' parentAd={TOP_10} adGenreId={neededGenreId} podcast={podcast} showSubscribe={true} size='lg' />
                                    </div>
                                )
                            }
                        </AppSideScroll>
                    </div>
                )}
            </div>
        )
    }
}

RelevantPodcasts.propTypes = {
    userDetails: PropTypes.object,
    subscribedPodcasts: PropTypes.object,
    adPodcasts: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        adPodcasts: state.adPodcasts,
    }
}

// const mapDispatchToProps = (dispatch) => {
//     return {
//     }
// };

export default connect(mapStateToProps, null)(RelevantPodcasts);